// 共享的菜单数据
export const menuItems = [
  { index: '1', label: '首页', path: '/home' },
  { index: '2', label: '碳芯', path: '/production' },
  { index: '3', label: '碳知', path: '/service' },
  { index: '4', label: '碳行', path: '/pioneer' },
  { index: '5', label: '关于中碳', path: '/about' }
]

// 共享的页面跳转方法
export function changePage(index, router) {
  const item = menuItems.find(item => item.index === index)
  if (item && item.path && router) {
    router.push(item.path).catch((v) => {})
  }
}